import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  /** `narrow` for single-purpose screens (login, errors); `wide` for lists (admin). */
  width?: 'narrow' | 'wide';
  /** Vertically center the content (login / error screens). */
  center?: boolean;
}

export function Layout({ children, width = 'narrow', center = false }: LayoutProps) {
  const maxWidth = width === 'wide' ? 'max-w-2xl' : 'max-w-md';
  return (
    <div className="min-h-dvh bg-surface text-neutral-900 dark:text-neutral-100">
      <main
        className={`mx-auto flex w-full ${maxWidth} flex-col px-4 pb-10 pt-4 sm:px-6 ${
          center ? 'min-h-dvh justify-center' : ''
        }`}
      >
        {children}
      </main>
    </div>
  );
}
